module.exports = __webpack_public_path__ + "static/img/cl.5b93fbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/cl.png
// module id = Puwb
// module chunks = 18